import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for", "data-required"]
const _hoisted_2 = {
  key: 0,
  class: "form-field__error"
}

import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';

interface Props {
    id: string;
    label: string;
    modelValue?: string;
    disabled?: boolean;
    error?: string;
    required?: boolean;
    capitalize?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FormField',
  props: {
    id: {},
    label: {},
    modelValue: { default: undefined },
    disabled: { type: Boolean, default: false },
    error: { default: undefined },
    required: { type: Boolean, default: false },
    capitalize: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

/* eslint-env vue/setup-compiler-macros */
const props = __props;

const emit = __emit;

function capitalizeWords(value: string): string {
    return value.replace(/(^|[\s'-])([a-z])/g, (match) => match.toUpperCase());
}

function handleUpdate(value: string) {
    emit('update:modelValue', props.capitalize ? capitalizeWords(value) : value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['form-field', { 'form-field--invalid': !!__props.error }])
  }, [
    _createVNode(_unref(FloatLabel), {
      variant: "on",
      class: "form-field__float"
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createVNode(_unref(InputText), {
            id: __props.id,
            class: "form-field__input",
            "model-value": __props.modelValue,
            disabled: __props.disabled,
            autocapitalize: __props.capitalize ? 'words' : undefined,
            placeholder: " ",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (handleUpdate($event as string)))
          }, null, 8, ["id", "model-value", "disabled", "autocapitalize"])
        ]),
        _createElementVNode("label", {
          for: __props.id,
          "data-required": __props.required ? 'true' : 'false'
        }, _toDisplayString(__props.label), 9, _hoisted_1)
      ]),
      _: 3
    }),
    (__props.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.error), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})